import React, { useState } from "react";
import { FixtureWarningWrapper } from "./styles";
import FixtureWarningIcon from "../../assets/Icons_Fixture_Warning.png";
import FixtureWarningBox from "./FixtureWarningBox";
import { StatsType, Contestant } from "../../../../types/fixture";

interface Props {
  stats: StatsType[];
  eventContestants: Contestant[];
}

function FixtureWarning({ stats, eventContestants }: Props) {
  const [displayFixtureWarning, setDisplayFixtureWarning] = useState(false);

  const showFixtureWarning = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    setDisplayFixtureWarning(!displayFixtureWarning);
  };

  return (
    <FixtureWarningWrapper>
      <button type="button" onClick={(e) => showFixtureWarning(e)}>
        <img src={FixtureWarningIcon} alt="Fixture Warning Icon" />
      </button>
      {displayFixtureWarning ? (
        <FixtureWarningBox stats={stats} eventContestants={eventContestants} />
      ) : null}
    </FixtureWarningWrapper>
  );
}

export default FixtureWarning;
